/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_AddInputs */

const en_us2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a note`)
};

const pt_br2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar nota`)
};

const es_419_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar una nota`)
};

const pt_pt2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar nota`)
};

const fr_fr2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une note`)
};

const de_de2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz hinzufügen`)
};

const it_it2_exercise_personal_note_add = /** @type {(inputs: Exercise_Personal_Note_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi una nota`)
};

/**
* | output |
* | --- |
* | "Add a note" |
*
* @param {Exercise_Personal_Note_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_add = /** @type {((inputs?: Exercise_Personal_Note_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_add(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_add(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_add(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_add(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_add(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_add(inputs)
	return en_us2_exercise_personal_note_add(inputs)
});
export { exercise_personal_note_add as "exercise-personal.note_add" }